var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"js-tiny-mde-container"},[_c('div',{staticClass:"js-tiny-mde-toolbar",attrs:{"data-commands":_vm.toolbar}}),_vm._v(" "),_c('textarea',{ref:"textarea",staticClass:"js-tiny-mde",attrs:{"data-image-drop":_vm.imageDropEnabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }